import type { CustomerLoginRouterScope } from "@Front/Components/Layouts/Login/helpers/customerLoginRouterScope";
import { usePasswordForgot, type UsePasswordForgotOptions } from "@Front/Components/Layouts/Login/hooks/helpers/loginPasswordAndResendHooks";
import {
	useSendAnotherCode,
	type UseSendAnotherCodeOptions,
} from "@Front/Components/Layouts/Login/hooks/helpers/loginSendAnotherCodeHook";
import type { CustomerLoginState } from "@Front/Components/Layouts/Login/hooks/helpers/loginStateHook";

function buildPasswordForgotRecoveryOpts(
	loginScope: CustomerLoginRouterScope,
	loginState: CustomerLoginState,
): UsePasswordForgotOptions {
	const { setStep, email, authDisambiguation, setPartialPhoneNumber, setDeliveryChannel, setMaskedEmail, setTotpCodeUid, setValidationErrors } = loginState;
	return {
		email,
		...loginScope,
		authDisambiguation,
		setPartialPhoneNumber,
		setDeliveryChannel,
		setMaskedEmail,
		setTotpCodeUid,
		setValidationErrors,
		setStep,
	};
}

function buildSendAnotherRecoveryOpts(
	loginScope: CustomerLoginRouterScope,
	loginState: CustomerLoginState,
): UseSendAnotherCodeOptions {
	const { totpCodeUid, email, authDisambiguation, setValidationErrors, setPartialPhoneNumber, setDeliveryChannel, setMaskedEmail, setTotpCodeUid } =
		loginState;
	return {
		email,
		totpCodeUid,
		loginScope,
		authDisambiguation,
		setValidationErrors,
		setPartialPhoneNumber,
		setDeliveryChannel,
		setMaskedEmail,
		setTotpCodeUid,
	};
}

export function useLoginPasswordRecoveryCallbacks(params: {
	loginScope: CustomerLoginRouterScope;
	loginState: CustomerLoginState;
}): {
	onPasswordForgotClicked: () => void;
	onSendAnotherCode: () => void;
} {
	const { loginScope, loginState } = params;
	return {
		onPasswordForgotClicked: usePasswordForgot(buildPasswordForgotRecoveryOpts(loginScope, loginState)),
		onSendAnotherCode: useSendAnotherCode(buildSendAnotherRecoveryOpts(loginScope, loginState)),
	};
}
